import PolarisIcon from '@/components/_common/PolarisIcon';
import { Grid } from '@mui/material';
import styled from '@emotion/styled';

const OPOrderStep = ({ active = false, completed = false, heading = '', description = '', ...props }) => {
  return (
    <Wrapper active={active} completed={completed} container {...props}>
      <OrderStepIcon icon={completed ? 'complete_duotone' : 'pending'} className="order-step-icon" />
      <div>
        <h2>{heading}</h2>
        <p>{description}</p>
      </div>
    </Wrapper>
  );
};

export default OPOrderStep;

const Wrapper = styled(Grid, {
  shouldForwardProp: (prop) => !['active', 'completed'].includes(prop)
})<{ active: boolean; completed: boolean }>`
  padding: ${(props) => props.theme.spacing(2)};
  margin-bottom: ${(props) => props.theme.spacing(2)};
  opacity: 0.5;
  & h2,
  & p {
    margin: 0;
  }
  & h2 {
    font-size: 1.2rem;
  }
  & p {
    font-size: 0.95rem;
    opacity: 0.5;
  }

  ${(props) =>
    props.active
      ? `
    opacity: 1;
    & .order-step-icon {
      color: ${props.theme.palette.primary.main};
    }
  `
      : null};

  ${(props) =>
    props.completed
      ? `
    opacity: 1;
    & .order-step-icon {
      color: ${props.theme.palette.teal.main};
    }
  `
      : null};
`;

const OrderStepIcon = styled(PolarisIcon)`
  font-size: 2.5rem;
  color: ${(props) => props.theme.palette.action.disabled};
  margin-top: ${(props) => props.theme.spacing(1)};
  margin-right: ${(props) => props.theme.spacing(1.5)};
`;
